// used both at runtime and build time
module.exports = {
  styleScope: 'cdf-solutions-ui-style-scope',
};
